import { AccessProfileModel } from "../AccessProfile/AccessProfileModel";
import { UserTypeModel } from "./UserTypeModel";

export class UserModel {
    id?: number;
    username?: string;
    password?: string;
    partner_id?: string;
    partner_code?: string;
    name?: string;
    email?: string;
    role?: string;
    access_profile?: AccessProfileModel;
    user_type?: UserTypeModel;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
}